import { useMemo, useState } from 'react';
import defaultIMG from '@/assets/imgs/cards/bg5.png';
import {
  Button,
  CardHolderForm,
  CreateNewCard,
  Image,
  LoadingStatus,
  SuccessStatus,
} from '@/components/generic';
import {
  useCreateUserCardHolder,
  useGetCardHolderData,
} from '@package/smart-wallet/hooks';

export const CreateNewCardHolder = ({
  onClose,
  cardTypeData,
}: {
  onClose: () => void;
  cardTypeData?: any;
}) => {
  const [
    isCardHolderCreatednReadyForCreateCard,
    setIsCardHolderCreatednReadyForCreateCard,
  ] = useState(false);
  const [isFakeLoading, setIsFakeLoading] = useState(false);
  const {
    isLoading: isLoadingCardHolder,
    cardHolderInfo,
    refetch: refetchCardHolderInfo,
  } = useGetCardHolderData();
  const {
    register,
    isLoading: isLoadingRegister,
    error: errorregister,
  } = useCreateUserCardHolder({});
  const cardHolderModel: 'B2B' | 'B2C' = 'B2C';
  const isB2C = cardHolderModel === 'B2C';

  const handleFakeLoading = async () => {
    refetchCardHolderInfo();
    setIsFakeLoading(true);
    await new Promise((resolve) => setTimeout(resolve, 5000));
    setIsFakeLoading(false);
  };

  const successHandler = () => {
    if (isB2C) {
      onClose();
      window.location.reload();
      return;
    }
    // non-physical cards: continue to card creation flow
    setIsCardHolderCreatednReadyForCreateCard(true);
  };
  const isCardHolderPass = useMemo(() => {
    if (!cardHolderInfo?.records || !cardTypeData?.cardTypeId) {
      return false;
    }
    return cardHolderInfo.records.some(
      (record) =>
        record.cardTypeId === cardTypeData.cardTypeId &&
        record?.status !== 'pass_audit',
    );
  }, [cardHolderInfo, cardTypeData?.cardTypeId]);
  const isRegisteredCardHolder = useMemo(() => {
    if (!cardHolderInfo?.records || !cardTypeData?.cardTypeId) {
      return false;
    }
    // Check if there's a record with the same cardTypeId
    return cardHolderInfo.records.some(
      (record) => record.cardTypeId === cardTypeData.cardTypeId,
    );
  }, [cardHolderInfo, cardTypeData?.cardTypeId]);
  if (isCardHolderCreatednReadyForCreateCard) {
    return <CreateNewCard onClose={() => onClose()} cardTypeData={cardTypeData} />;
  }
  if (isLoadingRegister || isLoadingCardHolder || isFakeLoading) {
    return <LoadingStatus />;
  }
  if (isCardHolderPass) {
    return (
      <>
        <div className='flex justify-center items-center size-16 mb-8 bg-primary-03/15 rounded-full mx-auto'>
          <Image className='size-6 opacity-100' src={defaultIMG} alt='' />
        </div>
        <div className='mb-4 text-h4 max-md:text-h5 text-t-primary text-center'>
          Card Holder Under Review
        </div>
        <div className='mb-8 text-body-2 font-medium text-t-tertiary text-center'>
          Your card holder application is currently being reviewed. This process
          may take some time. Please check back later or contact support if you
          have any questions.
        </div>
        <div className='flex justify-end gap-3 mt-8'>
          <Button isGray className='flex-1' onClick={() => handleFakeLoading()}>
            ReFresh Status
          </Button>
        </div>
        <div className='flex justify-end gap-3 mt-8'>
          <Button className='flex-1' isBlack onClick={() => onClose()}>
            Close
          </Button>
        </div>
      </>
    );
  }
  if (isRegisteredCardHolder) {
    return (
      <SuccessStatus
        title='Card Holder Created'
        content='Your card holder is been under review and will be available soon. Please check back later once the its application is approved.'
        onClose={() => successHandler()}
        confirm={() => successHandler()}
      />
    );
  }
  return (
    <>
      <div className='mb-8 text-h4 max-md:text-h5 text-t-primary'>
        Create New Card Holder
      </div>
      <div className='flex items-center mb-2'>
        <div className='shrink-0'>
          <Image
            className='aspect-[3/2] w-20 !rounded-[2px] [&>*]:object-cover'
            src={defaultIMG}
          />
        </div>
        <div className='w-[calc(100%-5rem)] pl-6'>
          <div className='truncate text-h6 text-t-primary'>Google Pay</div>
          <div className='truncate text-h6 text-t-primary'>Apple Pay</div>
        </div>
      </div>
      <div className='mb-8 text-body-2 font-medium text-t-tertiary'>
        You're creating a new card holder for this type of card, <br />
        <span className='text-primary-02'>Create Card Holder</span> and please
        ensure you have sufficient balance in your account to cover the card
        issuance fee.
      </div>
      <CardHolderForm
        mode='create'
        cardTypeId={cardTypeData?.cardTypeId?.toString() || ''}
        onSubmit={(data) => register(data)}
        submitLabel='Create Card Holder'
        isSubmitting={isLoadingRegister}
        error={errorregister}
        onCancel={onClose}
        showTerms
      />
    </>
  );
};
